import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardOut32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconClipboardOut32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2h1a4 4 0 0 1 4 4v5h-2V9a2 2 0 0 0-2-2h-1a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2H9a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h3v2H9a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4zm2 0v2h6V5zm.293 9.293a1 1 0 0 1 1.415 0L24 24.588V19a1 1 0 1 1 2 0v9h-9a1 1 0 1 1 0-2h5.584l-10.29-10.293a1 1 0 0 1 0-1.414"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardOut32);
